module.exports = __webpack_public_path__ + "img/team-v01.d08e7cf4.png";